import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { getMenusApi } from '../api.service';
import type { User } from '@/core/types/auth';

export type MenuItemType = {
    id: number;
    icon: string | null;
    label: string;
    url: string | null;
    isReport: boolean | null;
    subMenu: MenuItemType[];
    docType?: string;
    listChild?: boolean;
    subDocType?: string;
};

type MenuResponse = {
    data?: MenuItemType[];
};

export const useMenus = (user?: User | null): UseQueryResult<MenuItemType[]> => {
    return useQuery<MenuItemType[]>({
        queryKey: ['menus', user?.docNo],
        queryFn: async () => {
            const response = await getMenusApi();
            const payload = response?.data as MenuResponse | MenuItemType[] | undefined;
            let menus: MenuItemType[] = [];
            
            if (Array.isArray(payload)) {
                menus = payload;
            } else if (payload && Array.isArray(payload.data)) {
                menus = payload.data;
            }
            
            // Add TRACK menu item if it doesn't exist
            const hasTrackMenu = menus.some(menu => menu.url === '/master/TRACK' || menu.label.toLowerCase() === 'tracking' || menu.label.toLowerCase() === 'track');
            if (!hasTrackMenu) {
                // Generate a unique ID that doesn't conflict with existing menu IDs
                const existingIds = menus.map(m => m.id);
                const maxId = existingIds.length > 0 ? Math.max(...existingIds) : 0;
                const trackMenu: MenuItemType = {
                    id: maxId + 1,
                    icon: null,
                    label: 'Tracking',
                    url: '/master/TRACK',
                    isReport: false,
                    subMenu: [],
                };
                menus.push(trackMenu);
            }
            
            return menus;
        },
        initialData: [],
        enabled: Boolean(user),
        retry: 1,
    });
};
